export const WEEKDAYS = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' },
];

export const TIME_SLOTS = [
  { key: 'h08', label: '08:00 - 11:00' },
  { key: 'h11', label: '11:00 - 14:00' },
  { key: 'h14', label: '14:00 - 17:00' },
  { key: 'h17', label: '17:00 - 20:00' },
];

export const emptyScheduleMatrix = () =>
  TIME_SLOTS.reduce((acc, { key }) => {
    acc[key] = WEEKDAYS.reduce(
      (row, day) => ({ ...row, [day.key]: 0 }),
      {},
    );
    return acc;
  }, {});

export const defaultSendSchedule = () => ({
  enabled: false,
  matrix: emptyScheduleMatrix(),
});
